var _ellipse, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9021,
    cy: 17.898,
    rx: 17.3611,
    ry: 17.4107,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6448 8.53809H12.1582C10.1787 8.53809 8.56836 10.153 8.56836 12.138V23.6576C8.56836 25.6425 10.1787 27.2575 12.1582 27.2575H23.6448C25.6233 27.2575 27.2344 25.6425 27.2344 23.6576V12.138C27.2344 10.153 25.6233 8.53809 23.6448 8.53809ZM25.7986 23.6576C25.7986 24.8491 24.832 25.8175 23.6448 25.8175H12.1582C10.9699 25.8175 10.0045 24.8491 10.0045 23.6576V12.138C10.0045 10.9471 10.9699 9.97802 12.1582 9.97802H23.6448C24.832 9.97802 25.7986 10.9471 25.7986 12.138V23.6576Z",
    fill: "url(#paint0_linear_331_242)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1822 15.918V14.8381H20.9773V9.61816H19.9003V14.8381H15.9516V9.61816H14.875V14.8381H9.66992V15.918H14.875V19.8778H9.66992V20.9577H14.875V26.1775H15.9516V20.9577H19.9003V26.1775H20.9773V20.9577H26.1822V19.8778H20.9773V15.918H26.1822ZM19.9003 19.8778H15.9516V15.918H19.9003V19.8778Z",
    fill: "url(#paint1_linear_331_242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_242",
    x1: 24.0197,
    y1: 0.52044,
    x2: -10.7212,
    y2: 55.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489999,
    stopColor: "#CA2C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#971994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_331_242",
    x1: 23.3384,
    y1: 2.52568,
    x2: -7.39367,
    y2: 50.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489999,
    stopColor: "#CA2C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#971994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentFeed);
export default __webpack_public_path__ + "static/media/content-feed.8617031625088a04d120fbe0501883f4.svg";
export { ForwardRef as ReactComponent };